export default function getExerciseSvgImage(entry) {
  if (!entry) return null
  const data = {}
  const exerciseImage = entry.exerciseContent?.[0]?.exerciseFigure?.[0]?.exerciseSvgImage?.[0]?.url || false
  const exerciseImageDate = entry.exerciseContent?.[0]?.exerciseFigure?.[0]?.exerciseSvgImage?.[0]?.dateUpdated || false
  const timestamp = exerciseImageDate
    ? `${new Date(exerciseImageDate).getMinutes()}${new Date(exerciseImageDate).getSeconds()}`
    : false
  if (!exerciseImage) return false
  data.url = `${exerciseImage}${timestamp ? `?t=${timestamp}` : ''}`
  data.alt = entry?.exerciseTitle || ''
  return data
}
